import type { ReactNode } from "react";

/** Main document column for knowledge / org surfaces — optional right aside rail. */
export const MORROW_DOCUMENT_COLUMN_CLASS = "min-w-0 w-full";

const MORROW_DOCUMENT_READING_WIDTH_CLASS = "mx-auto w-full max-w-[42rem]";

export function MorrowDocumentColumn({
  children,
  aside,
}: {
  readonly children: ReactNode;
  readonly aside?: ReactNode;
}) {
  if (!aside) {
    return <div className={MORROW_DOCUMENT_READING_WIDTH_CLASS}>{children}</div>;
  }

  return (
    <div className="mx-auto grid w-full max-w-[62rem] items-start gap-6 lg:grid-cols-[minmax(0,42rem)_minmax(12rem,18rem)] lg:gap-8">
      <div className={MORROW_DOCUMENT_COLUMN_CLASS}>{children}</div>
      <aside className="min-w-0 lg:max-w-[18rem]">{aside}</aside>
    </div>
  );
}
